import { z } from "zod";

import {
	VoucherForCampaignInputSchema,
	VoucherForCampaignUserItemInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

import {
	chillnnDateZodSchema,
	priceObjectZodSchema,
	s3ObjectZodSchema,
} from "@/components/features/_shared/validation-schema/validation-schema";

export const voucherForCampaignInputSchema = VoucherForCampaignInputSchema.extend({
	name: z.string().min(1).max(100),
	description: z.string().min(1).max(300),
	voucherExplanationForHost: z.string().min(1).max(300),
	mailTemplate: z.string().min(1).max(3000),

	mainKeyVisual: s3ObjectZodSchema,

	cinStart: chillnnDateZodSchema,
	cinEnd: chillnnDateZodSchema,

	resourceAvailablePrice: priceObjectZodSchema,
	voucherPrice: priceObjectZodSchema,

	voucherGiftList: z.array(
		VoucherForCampaignUserItemInputSchema.extend({
			guestName: z.string().min(1).max(100),
			guestEmail: z.string().email().or(z.literal(undefined)),
			guestTel: z.string().max(15),
		}),
	),
});

export type VoucherForCampaignInputSchema = z.infer<typeof voucherForCampaignInputSchema>;
